<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>داشبورد سفارشات من</span>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <MyOrderListDesktop/>
    </q-card-section>
  </q-card>
</template>

<script>
import MyOrderListDesktop from "@/components/Visitors/MyOrderListDesktop";
export default {
  name: "MyOrderList",
  components: { MyOrderListDesktop}
}
</script>

<style scoped>

</style>